import React, { useEffect } from "react";

// URL da landing page hospedada no Canva. Quando o usuário acessa
// /landingpage no nosso domínio, redireciona para o Canva.
// Não é "mascaramento" verdadeiro (a URL final fica visível), mas é
// um atalho amigável que dá controle ao admin caso a landing mude no futuro.
const LANDING_URL = "https://gestaoexpertapp.my.canva.site/";

export default function LandingRedirect() {
  useEffect(() => {
    // window.location.replace para não adicionar ao histórico
    window.location.replace(LANDING_URL);
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-white dark:from-[#0A0F19] dark:to-[#050810]">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-10 w-10 border-2 border-emerald-600 border-t-transparent"/>
        <p className="text-sm text-neutral-500 mt-4">Carregando Gestão Expert…</p>
        <p className="text-xs text-neutral-400 mt-1">
          Caso não seja redirecionado, <a href={LANDING_URL} className="text-emerald-600 underline">clique aqui</a>.
        </p>
      </div>
    </div>
  );
}
